import { Box, Flex, Button } from 'rebass/styled-components';

const ContentBox = ({ children, maxWidth = "792px", pt = 0, bg = 'lightYellow', showBorder, sx, ...props }) => (
    <Box
        sx={{
            bg: bg
        }}
        pt={pt}
    >
        <Box
            width={[1, 1, '1280px']}
            mx="auto"
            px="3"
            maxWidth={maxWidth}
            py={4}
            sx={{
                ...sx
            }}
            id="about"
            {...props}
        >

            {children}

            {showBorder && (
                <Box
                    sx={{
                        opacity: '0.2',
                        width: '100%',
                        height: '0px',
                        borderBottomStyle: 'solid',
                        borderBottomWidth: '1px',
                        borderBottomColor: 'gold',
                    }}
                ></Box>
            )}
        </Box>
    </Box>
);

export default ContentBox;
